var map = {
	"./": 1387,
	"./Clutch": 2702,
	"./Clutch.js": 2702,
	"./NewUi": 2703,
	"./NewUi.js": 2703,
	"./OldUi": 2704,
	"./OldUi.js": 2704,
	"./index": 1387,
	"./index.js": 1387,
	"./style": 858,
	"./style.js": 858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4247;